import { datadogLogs } from '@datadog/browser-logs';
import getConfig from 'next/config';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Context } from '@datadog/browser-core';

type Logger = {
  info: typeof datadogLogs.logger.info;
};

const createDataDogLogger = (): Logger => {
  const { publicRuntimeConfig } = getConfig();
  datadogLogs.init({
    clientToken: publicRuntimeConfig.dataDogClientToken,
    forwardErrorsToLogs: true,
    sampleRate: 100,
    service: 'consumer-app-frontend',
    site: 'datadoghq.com',
    trackInteractions: false,
  });
  return datadogLogs.logger;
};

const createNoOpLogger = (): Logger => {
  return {
    info: () => {},
  };
};

const createLogger = (): Logger => {
  const { publicRuntimeConfig } = getConfig();
  return publicRuntimeConfig.production ? createDataDogLogger() : createNoOpLogger();
};

const logger = createLogger();

export const logEvent = (event: string, context?: Context): void => {
  logger.info(event, context);
};
